import { useEffect } from 'react';

import type { TGlobalDataModel } from '@/_models';
import { useUrlParams, Routes, useNav, withHookMoveToLink } from '@/_navigation';

interface IProps {
  doNotCheckDataAnomaly: boolean;
  leadData: TGlobalDataModel;
  overrideGlobalData: (p: TGlobalDataModel, forceOverride?: boolean) => void;
}

export default function useDataValidation({
  doNotCheckDataAnomaly,
  leadData: { leadId: localLeadId, campusId: localCampusId, summaryId: localSummaryId },
  overrideGlobalData,
}: IProps) {
  const goto = useNav();
  const { paramSummaryId, paramCampusId, paramLeadId } = useUrlParams();
  /**
   * Reset data on load
   * URL Params and local storage do not match
   */
  useEffect(() => {
    if (!paramLeadId) {
      // console.log('paramLeadId is not init');
    }
    if (doNotCheckDataAnomaly) {
      // console.log('Data Anomaly check avoided');
      return;
    }

    if (
      !isValidLeadSummaryCampus({
        paramLeadId,
        localLeadId,
        paramCampusId,
        localCampusId,
        paramSummaryId,
        localSummaryId,
      })
    ) {
      // !important to use this hook function with forceOverride
      overrideGlobalData({} as TGlobalDataModel, true);
      console.warn('Data anomaly detected sending to main page');

      // !important to use this hook function
      withHookMoveToLink(goto, paramLeadId, Routes.BRIDGE_PLAN.link as string);
    }
  }, [
    doNotCheckDataAnomaly,
    localCampusId,
    localLeadId,
    localSummaryId,
    paramCampusId,
    paramLeadId,
    paramSummaryId,
    overrideGlobalData,
    goto,
  ]);
}

export function isValidLeadSummaryCampus({
  paramLeadId,
  paramCampusId,
  paramSummaryId,
  localLeadId,
  localCampusId,
  localSummaryId,
}: {
  paramLeadId?: string;
  localLeadId?: string;
  paramCampusId?: string;
  localCampusId?: string;
  paramSummaryId?: string;
  localSummaryId?: string;
}) {
  return !(
    (typeof localLeadId === 'string' && paramLeadId !== localLeadId) ||
    (typeof localCampusId === 'string' && paramCampusId !== localCampusId) ||
    (typeof localSummaryId === 'string' && paramSummaryId !== localSummaryId)
  );
}
